import {
  ProfessionalsReferencesListingStore,
  ProfessionalsReferencesListingActions,
} from './types';

export const defaultState: ProfessionalsReferencesListingStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  errorFilters: null,
  isLoadingFilters: false,
  isLoadedFilters: false,
  errorCount: null,
  isLoadingCount: false,
  isLoadedCount: false,
  references: [],
  referencesCount: -1,
  pagination: 0,
  referenceCategories: [],
  locationTypes: [],
  countries: [],
  filters: {
    referenceCategories: [],
    countries: [],
    locationTypes: [],
  },
};

const reducer = (
  state: ProfessionalsReferencesListingStore = defaultState,
  action: { type: ProfessionalsReferencesListingActions; payload?: any }
): ProfessionalsReferencesListingStore => {
  const {
    FetchListingBegin,
    FetchListingError,
    FetchListingSuccess,
    FetchFiltersBegin,
    FetchFiltersSuccess,
    FetchFiltersError,
    FetchCountBegin,
    FetchCountSuccess,
    FetchCountError,
    // SetCategoryFilter,
    // SetRegionFilter,
    // SetRoomFilter,
    SetFilters,
    SeeMoreReferences,
  } = ProfessionalsReferencesListingActions;
  switch (action.type) {
    case FetchListingBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case FetchListingError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case FetchListingSuccess: {
      const { pagination, references, ...payload } = action.payload;
      return {
        ...state,
        ...payload,
        //If pagination is true ("See more" action), concatenate references. Otherwise replace all of them (e.g. when filtering)
        references: pagination ? [...state.references, ...references] : [...references],
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }
    //Filter data
    case FetchFiltersBegin:
      return {
        ...state,
        isLoadingFilters: true,
        isLoadedFilters: false,
        errorFilters: null,
      };
    case FetchFiltersSuccess:
      return {
        ...state,
        ...action.payload,
        isLoadingFilters: false,
        isLoadedFilters: true,
        errorFilters: null,
      };
    case FetchFiltersError:
      return {
        ...state,
        isLoadingFilters: false,
        isLoadedFilters: true,
        errorFilters: action.payload,
      };

    // Reference Count
    case FetchCountBegin:
      return {
        ...state,
        isLoadingCount: true,
        isLoadedCount: false,
        errorCount: null,
      };
    case FetchCountSuccess:
      return {
        ...state,
        ...action.payload,
        isLoadingCount: false,
        isLoadedCount: true,
        errorCount: null,
      };
    case FetchCountError:
      return {
        ...state,
        isLoadingCount: false,
        isLoadedCount: true,
        errorCount: action.payload,
      };

    case SetFilters: {
      return {
        ...state,
        //Active categories to display
        filters: action.payload,
      };
    }
    // case SetRegionFilter: {
    //   return {
    //     ...state,
    //     filters: {
    //       ...state.filters,
    //       countries: action.payload,
    //     },
    //   };
    // }
    // case SetRoomFilter: {
    //   return {
    //     ...state,
    //     filters: {
    //       ...state.filters,
    //       locationTypes: action.payload,
    //     },
    //   };
    // }
    case SeeMoreReferences: {
      return {
        ...state,
        pagination: state.pagination++,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
